@if (listConfigs) {
  <gk-dynamic-list
    [listConfigs]="listConfigs"
    [listState]="listState"
    (dispatchMapAction)="handleMapAction($event)"
  ></gk-dynamic-list>
}
